var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCampaigns = function SvgCampaigns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "14 14 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".campaigns_svg__a_PUNISJ19{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "campaigns_svg__a_PUNISJ19",
    d: "M0 0h44v44H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "campaigns_svg__a_PUNISJ19",
    d: "M10 10h24v24H10z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.205 7.294H3.641A1.644 1.644 0 0 0 2 8.941v3.294a1.644 1.644 0 0 0 1.641 1.647h.821v3.294a.822.822 0 0 0 .82.824h1.641a.822.822 0 0 0 .821-.824v-3.294h2.462l4.1 3.294V4l-4.1 3.294M18 10.588a3.638 3.638 0 0 1-2.051 3.294V7.294A3.671 3.671 0 0 1 18 10.588Z",
    transform: "translate(12 11)",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgCampaigns;